/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { Point } from 'pixi.js-legacy';
import { MatMenuTrigger } from '@angular/material/menu';

export enum CONTEXT_MENUS {
	TICKET_QUICK_STATUS = 'quickStatus',
	TICKET_EDIT_CONFIRM_MENU = 'editConfirm',
}

export interface IContextMenu {
	contextMenu: any;
	onChanged: (newData: IContextMenuData) => any;
	trigger?: MatMenuTrigger;
}

export interface IContextMenuData {
	x: number;
	y: number;
	data: any;
}

@Injectable({
	providedIn: 'root',
})
export class ContextMenuService {
	public activeMenus$: BehaviorSubject<Map<string, IContextMenu>> = new BehaviorSubject(new Map());

	private registeredContextMenus: Map<string, IContextMenu> = new Map();

	constructor() {}

	public register(id: string, component: IContextMenu): Subject<IContextMenuData> {
		this.registeredContextMenus.set(id, component);
		return new Subject();
	}

	public remove(id: string): void {
		this.registeredContextMenus.delete(id);
	}

	public show(id: string, point: Point, extraData = {}): void {
		const menu = this.registeredContextMenus.get(id);
		if (!menu) {
			return;
		}
		menu.trigger?.closeMenu();
		menu.onChanged({ x: point.x, y: point.y, data: extraData });
		setTimeout(() => menu.trigger?.openMenu(), 200); // slight delay in timing to make animation less jarring
		const menusShowing = this.activeMenus$.getValue();
		if (!menusShowing.get(id)) {
			menusShowing.set(id, menu);
			this.activeMenus$.next(menusShowing);
		}
	}

	public hide(id: string): void {
		const menu: any = this.registeredContextMenus.get(id);
		if (!menu) {
			return;
		}
		menu.trigger?.closeMenu();
		const menusShowing = this.activeMenus$.getValue();
		if (menusShowing.get(id)) {
			menusShowing.delete(id);
			this.activeMenus$.next(menusShowing);
		}
	}

	public hideAll(): void {
		this.registeredContextMenus.forEach((menu: IContextMenu) => {
			menu.trigger?.closeMenu();
		});
		const menusShowing = this.activeMenus$.getValue();
		menusShowing.clear();
		this.activeMenus$.next(menusShowing);
	}

	public getMenu(id: string): any {
		return this.registeredContextMenus.get(id);
	}
}
